/*
 * Copyright (C) 2025 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component } from '@angular/core';
import { TooltipPosition } from './tooltip.directive';

export const TOOLTIP_POSITION_CLASSES: Record<TooltipPosition, string> = {
  above:
    'mb-2 -translate-x-1/2 -translate-y-[calc(100%+0.5rem)] before:-bottom-2 before:border-t-[0.5rem] before:border-t-ozggray-900 dark:before:border-t-white',
  below: 'mt-2 -translate-x-1/2 before:-top-2 before:border-b-[0.5rem] before:border-b-ozggray-900 dark:before:border-b-white',
};

@Component({
  selector: 'ods-tooltip',
  host: { class: 'contents' },
  template: `<span
    popover="manual"
    [attr.data-test-id]="dataTestId"
    class="tooltip animate-fade-in bg-ozggray-900 text-whitetext fixed inset-auto z-9999 m-0 cursor-default overflow-visible rounded-sm border-0 px-3 py-2 text-sm font-normal wrap-break-word before:absolute before:border-r-[0.5rem] before:border-l-[0.5rem] before:border-r-transparent before:border-l-transparent dark:bg-white"
    [class]="positionClasses"
    [class.visible]="show"
    [class.invisible]="!show"
    [class.text-wrap]="width"
    [class.text-nowrap]="!width"
    [style.left.px]="left"
    [style.top.px]="top"
    [style.width.rem]="width"
    [style.--before-left.px]="leftOffset"
    [attr.id]="id"
    [attr.aria-hidden]="!show"
    role="tooltip"
  >
    {{ text }}
  </span>`,
  styleUrl: './tooltip.component.scss',
})
export class TooltipComponent {
  text: string = '';
  left: number = 0;
  top: number = 0;
  width: number = null;
  show: boolean = false;
  id: string;
  positionClasses: string;
  leftOffset: number;

  dataTestId: string;

  set position(value: TooltipPosition) {
    this.positionClasses = TOOLTIP_POSITION_CLASSES[value];
  }
}
